import React from 'react';
import PropTypes from 'prop-types';
import { useScreenViewEvent } from '@stitch-fix/event-reporter';
import { I18nProvider } from '@stitch-fix/i18n';
import ErrorBoundary from './ErrorBoundary';
import GraphQLApiProvider from './GraphQLApiProvider';
import packageInfo from '../../../../../package.json';

const appName = packageInfo.name;

const App = ({ children, v2ScreenViewData }) => {
  const { client_region: region, locale } = window.gon;

  const { EventProvider } = useScreenViewEvent({
    ...v2ScreenViewData,
    locale,
    region,
    source_app: appName,
  });

  return (
    <I18nProvider locale={locale}>
      <ErrorBoundary>
        <GraphQLApiProvider>
          <EventProvider>{children}</EventProvider>
        </GraphQLApiProvider>
      </ErrorBoundary>
    </I18nProvider>
  );
};

App.propTypes = {
  children: PropTypes.node.isRequired,
  v2ScreenViewData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const wrapRootComponents = componentMap => {
  return Object.entries(componentMap).reduce(
    (components, [componentName, { Component, getV2ScreenViewData }]) => {
      const newComponents = components;

      newComponents[componentName] = props => (
        <App v2ScreenViewData={getV2ScreenViewData(props)}>
          <Component {...props} />
        </App>
      );

      return newComponents;
    },
    {},
  );
};

export default wrapRootComponents;
